import type { Middleware } from '@reduxjs/toolkit';
import { sessionExpired } from 'redux/slices/user.slice';
import type { RootState } from 'redux/store';

import analytics from './analytics';

/**
 * Sends session_expired on a forced sign-out. Lives here, not in baseApi, because analytics imports the store.
 * Every request in flight when the session dies signs out, so only the first, while a user is still signed in, counts.
 */
const sessionEventsMiddleware: Middleware =
  ({ getState }) =>
  (next) =>
  (action) => {
    const isSignedIn = Boolean((getState() as RootState).user?.accessToken);
    if (sessionExpired.match(action) && isSignedIn) analytics.captureSessionExpired({ reason: action.payload });
    return next(action);
  };

export default sessionEventsMiddleware;
